import * as React from "react";
const Svg16PxVolume = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m8 1 6 3.5v7.01L8 15l-6-3.49V4.5zM2.86 5.5v5.51l4.71 2.74v-5.5zm10.29 0L8.44 8.26v5.48L13.15 11zM8.01 2.01 3.29 4.75 8.01 7.5l4.72-2.75z", style: {
  fill: "currentColor"
} }));
export default Svg16PxVolume;
